import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import WorkFlowStep from '@/components/workflow/WorkFlowStep';
export default {
  components: {
    PageNavBackLayoutCpt,
    WorkFlowStep
  },
  data() {
    return {
      businessId: null,
      workFlowDefinitionId: null
    };
  },
  created() {
    this.businessId = this.$route.params.businessId;
    this.workFlowDefinitionId = this.$route.params.workFlowDefinitionId;
  },
  mounted() {}
};